export const PDF_UTILS_TAB_TITLE = 'PDF_UTILS_TAB_TITLE'
export const PDF_UTILS_TAB_EDITOR = 'PDF_UTILS_TAB_EDITOR'



/** WEBPACK FOOTER **
 ** ./studio/constants.js
 **/